export default {
    attachmentsReceived: '{{documentsCount}} Documento(s) Adjuntos Recibidos',
    customer: 'Cliente',
    disputeAmount: 'Disputas Monto',
    disputeDate: 'Disputas Fecha',
    disputeDetails: 'Detalles de la disputa',
    disputeHistory: 'Historial de disputas',
    disputeID: 'ID de disputa',
    documentsReceived: 'Documentos recibidos',
    historyDetails: 'Detalles del historial de ID de disputa: {{disputeId}}',
    originalDisputeAmount: 'Monto original de la disputa',
    originalDisputeID: 'ID de disputa original',
    originalDisputeReason: 'Motivo original de la disputa',
    originalTransaction: 'Transacción Original',
    recommendedDocumentation: '<0>Recomendamos documentación</0>: {{disputeReason}}',
    synchrony: 'Synchrony'
};
//# sourceMappingURL=disputeDetails.js.map